import { useFeatureFlags } from './useFeatureFlags';
import { isInternalNetworkTunnelUiVisible } from '../utils/internal-network-tunnel-visibility';

export const useInternalNetworkTunnelVisibility = (): boolean => {
  const brokerFlag = useFeatureFlags('INTERNAL_NETWORK_TUNNEL_BROKER_ENABLED');
  const tailscaleFlag = useFeatureFlags('TAILSCALE_INTERNAL_APP_ENABLED');

  return isInternalNetworkTunnelUiVisible({
    brokerFetched: brokerFlag.isFetched,
    brokerEnabled: brokerFlag.isFeatureFlagEnabled,
    tailscaleFetched: tailscaleFlag.isFetched,
    tailscaleEnabled: tailscaleFlag.isFeatureFlagEnabled,
  });
};
